import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var _ACTIVATION_PAGE_BY_P;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Product } from '../../../graphql/__generated__/typeDefs';
import { Permission } from '../permissions';
import { deepMapLinks } from './linkUtils';
import { hasPermission } from '../Protected';
var ActivationPages = {
  synthetic: {
    productPermission: Permission.PINGDOM_VISIT,
    featureId: 'synthetic'
  },
  metrics: {
    productPermission: Permission.APPOPTICS_VISIT,
    featureId: 'metrics'
  },
  logs: {
    productPermission: Permission.LOGGLY_VISIT,
    featureId: 'logs'
  },
  rum: {
    productPermission: Permission.PINGDOM_VISIT,
    featureId: 'rum'
  },
  Apm: {
    productPermission: Permission.APPOPTICS_VISIT,
    featureId: 'apm'
  },
  Infrastructure: {
    productPermission: Permission.APPOPTICS_VISIT,
    featureId: 'infrastructure'
  }
};
export var ACTIVATION_PAGE_BY_NAV_KEY = {
  uptime: ActivationPages.synthetic,
  transaction: ActivationPages.synthetic,
  'page-speed': ActivationPages.synthetic,
  maintenance: ActivationPages.synthetic,
  'public-status': ActivationPages.synthetic,
  'email-reports': ActivationPages.synthetic,
  'report-banners': ActivationPages.synthetic,
  'probe-servers': ActivationPages.synthetic,
  rum: ActivationPages.rum,
  services: ActivationPages.Apm,
  hosts: ActivationPages.Infrastructure,
  containers: ActivationPages.Infrastructure,
  'log-explorer': ActivationPages.logs,
  'log-charts': ActivationPages.logs,
  'derived-fields': ActivationPages.logs,
  'source-setup': ActivationPages.logs,
  metrics: ActivationPages.metrics,
  'metric-alerts': ActivationPages.metrics,
  'log-alerts': ActivationPages.logs,
  'log-alert-endpoints': ActivationPages.logs
};
var ACTIVATION_PAGE_BY_PRODUCT = (_ACTIVATION_PAGE_BY_P = {}, _defineProperty(_ACTIVATION_PAGE_BY_P, Product.Loggly, ActivationPages.logs), _defineProperty(_ACTIVATION_PAGE_BY_P, Product.Pingdom, ActivationPages.synthetic), _defineProperty(_ACTIVATION_PAGE_BY_P, Product.Appoptics, ActivationPages.metrics), _defineProperty(_ACTIVATION_PAGE_BY_P, Product.Papertrail, undefined), _ACTIVATION_PAGE_BY_P);
export function insertActivationPageUrlsWhereNeeded(links, permissionContext, activationPageContext) {
  return deepMapLinks(links, function (link) {
    var activationPage = ACTIVATION_PAGE_BY_NAV_KEY[link.key];
    if (!activationPage) return link;
    var hasAccessToProduct = hasPermission(activationPage.productPermission, permissionContext);

    if (!hasAccessToProduct) {
      return _objectSpread(_objectSpread({}, link), {}, {
        href: getActivationPage(link.key, activationPageContext)
      });
    } else {
      return link;
    }
  });
}
export function getActivationPage(key, _ref) {
  var product = _ref.product,
      orgId = _ref.orgId,
      domains = _ref.domains;
  var feature = ACTIVATION_PAGE_BY_NAV_KEY[key] || product && ACTIVATION_PAGE_BY_PRODUCT[product] || undefined;
  var featureSuffix = feature ? '/' + feature.featureId : '';
  return "".concat(domains.common, "/settings/").concat(orgId, "/activate").concat(featureSuffix);
}